import { firebaseAction } from 'vuexfire'
import { binder } from './helpers'
import fb from '@/utilities/firebase-config'
export const db = fb.database() // alias here so firebase-mock works

export { fb }

export function createKeyAtPath(path = `/battles`) {
  return fb
    .database()
    .ref()
    .child(path)
    .push().key
}

export const bindStateToDb = binder(firebaseAction)(db)
